// extracted by mini-css-extract-plugin
export var link = "_r7-0";